import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { ArrowLeft } from "lucide-react";
import useSeo from "../lib/useSeo";

export default function LegalPage({ title, subtitle, lastUpdated, children }) {
  useSeo({
    title: title ? `${title} | Plate Buddies` : "Plate Buddies",
    description: subtitle || title || "Plate Buddies legal information.",
  });
  return (
    <div className="font-body bg-pb-cream min-h-screen">
      <Navbar />
      <section className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20">
        <Link
          to="/home"
          data-testid="legal-back-home"
          className="inline-flex items-center gap-2 text-sm font-bold text-pb-soft hover:text-pb-coral transition"
        >
          <ArrowLeft className="h-4 w-4" /> Back home
        </Link>

        <p className="mt-8 text-sm font-extrabold uppercase tracking-widest text-pb-coral">{subtitle}</p>
        <h1 className="font-display font-black text-4xl md:text-5xl mt-3 leading-tight">{title}</h1>
        <p className="mt-3 text-sm text-pb-soft italic">Last updated: {lastUpdated}</p>

        <article className="prose prose-pb mt-10 bg-white rounded-[2rem] p-8 sm:p-10 border border-pb-sky/30 shadow-[0_14px_32px_rgba(28,22,40,0.06)]">
          <style>{`
            .prose-pb h2 { font-family: "Outfit", ui-sans-serif, sans-serif; font-weight: 900; font-size: 1.5rem; margin: 2rem 0 0.75rem; color: #1C1628; }
            .prose-pb h3 { font-weight: 800; font-size: 1.05rem; margin: 1.5rem 0 0.5rem; color: #1C1628; }
            .prose-pb p  { color: #46485f; line-height: 1.7; margin: 0 0 1rem; font-size: 0.97rem; }
            .prose-pb ul { color: #46485f; line-height: 1.7; padding-left: 1.25rem; margin: 0 0 1rem; }
            .prose-pb li { margin: 0.35rem 0; }
            .prose-pb strong { color: #1C1628; }
            .prose-pb a { color: #F26A34; font-weight: 700; }
            .prose-pb a:hover { text-decoration: underline; }
          `}</style>
          {children}
        </article>

        <p className="mt-10 text-center text-xs text-pb-soft">
          Questions? Email us anytime at{" "}
          <a href="mailto:hello@platebuddies.com" className="text-pb-coral font-extrabold">
            hello@platebuddies.com
          </a>
          .
        </p>
      </section>
      <Footer />
    </div>
  );
}
